import PropTypes from 'prop-types';
import { Range } from 'react-range';

const CarFilter = ({ filters, setFilters }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleRangeChange = (values) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      minPrice: values[0],
      maxPrice: values[1],
    }));
  };

  return (
    <div className="mb-8">
      <hr className="my-4 border-gray-300 dark:border-gray-700 pb-2" />
      <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Filter Cars</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium pb-0 text-gray-700 dark:text-gray-300">Name</label>
          <input
            type="text"
            name="name"
            value={filters.name}
            onChange={handleInputChange}
            className="mt-1 block w-full h-7 border-red-600  dark:border-red-600 rounded-md shadow-sm bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white"
          />
        </div>
        <div className="col-span-2">
          <label className="block text-sm font-medium pb-4 text-gray-700 dark:text-gray-300">Price Range</label>
          <Range
            step={1}
            min={0}
            max={10000}
            values={[filters.minPrice, filters.maxPrice]}
            onChange={handleRangeChange}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                className="w-full h-2 bg-gray-300 dark:bg-gray-700 rounded-md"
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                className="w-5 h-4 bg-red-600 rounded-full shadow"
              />
            )}
          />
          <div className="flex justify-between mt-2 text-sm text-gray-700 dark:text-gray-300">
            <span>€{filters.minPrice}</span>
            <span>€{filters.maxPrice}</span>
          </div>
        </div>
      </div>
      <hr className="my-4 border-gray-300 dark:border-red-600 " />
    </div>
  );
};

CarFilter.propTypes = {
  filters: PropTypes.shape({
    name: PropTypes.string,
    maxPrice: PropTypes.number,
    minPrice: PropTypes.number,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};

export default CarFilter;
